export const PromptsByDay: Record<string, string> = {
  "2025-09-29": "egg",
  "2025-09-30": "orange",
  "2025-10-01": "toast",
  "2025-10-02": "syrup",
  "2025-10-03": "toaster",
  "2025-10-04": "rooster",
  "2025-10-05": "cereal",
  "2025-10-06": "pumpkin",
  "2025-10-07": "pie",
  "2025-10-08": "haystack",
  "2025-10-09": "rake",
  "2025-10-10": "turkey",
  "2025-10-11": "persimmon",
  "2025-10-12": "garlic",
  "2025-10-13": "traffic light",
  "2025-10-14": "bus",
  "2025-10-15": "stop sign",
  "2025-10-16": "wave",
  "2025-10-17": "ferry",
  "2025-10-18": "roundabout",
  "2025-10-19": "viaduct",
  "2025-10-20": "smile",
  "2025-10-21": "balloons",
  "2025-10-22": "sing",
  "2025-10-23": "birthday cake",
  "2025-10-24": "streamers",
  "2025-10-25": "clown",
  "2025-10-26": "hug",
  "2025-10-27": "lollipop",
  "2025-10-28": "bat",
  "2025-10-29": "spider web",
  "2025-10-30": "skeleton",
  "2025-10-31": "wizard",
  "2025-11-01": "graveyard",
  "2025-11-02": "surprise",
  "2025-11-03": "fish",
  "2025-11-04": "rope",
  "2025-11-05": "parrot",
  "2025-11-06": "bark",
  "2025-11-07": "aquarium",
  "2025-11-08": "whiskers",
  "2025-11-09": "beagle",
  "2025-11-10": "lemon",
  "2025-11-11": "crab",
  "2025-11-12": "buoy",
  "2025-11-13": "fishing",
  "2025-11-14": "oyster",
  "2025-11-15": "bib",
  "2025-11-16": "scallop",
  "2025-11-17": "cotton candy",
  "2025-11-18": "lemonade",
  "2025-11-19": "ferris wheel",
  "2025-11-20": "popcorn",
  "2025-11-21": "circus tent",
  "2025-11-22": "juggle",
  "2025-11-23": "rollercoaster",
  "2025-11-24": "football",
  "2025-11-25": "butter",
  "2025-11-26": "wheat",
  "2025-11-27": "eat",
  "2025-11-28": "potato",
  "2025-11-29": "nap",
  "2025-11-30": "parade",
  "2025-12-01": "sweater",
  "2025-12-02": "fireplace",
  "2025-12-03": "mitten",
  "2025-12-04": "armchair",
  "2025-12-05": "ball of yarn",
  "2025-12-06": "read",
  "2025-12-07": "puzzle",
  "2025-12-08": "icicle",
  "2025-12-09": "mountain",
  "2025-12-10": "pine tree",
  "2025-12-11": "ice skate",
  "2025-12-12": "snowflake",
  "2025-12-13": "deer",
  "2025-12-14": "hiker",
  "2025-12-15": "thermometer",
  "2025-12-16": "soup",
  "2025-12-17": "hospital",
  "2025-12-18": "tea",
  "2025-12-19": "medicine",
  "2025-12-20": "doctor",
  "2025-12-21": "sneeze",
  "2025-12-22": "cookie",
  "2025-12-23": "wreath",
  "2025-12-24": "Santa Claus",
  "2025-12-25": "choir",
  "2025-12-26": "stocking",
  "2025-12-27": "mistletoe",
  "2025-12-28": "snow",
  "2025-12-29": "calendar",
  "2025-12-30": "camera",
  "2025-12-31": "kiss",
  "2026-01-01": "champagne",
  "2026-01-02": "clap",
  "2026-01-03": "tuxedo",
  "2026-01-04": "fireworks",
  "2026-01-05": "bucket",
  "2026-01-06": "trash can",
  "2026-01-07": "broom",
  "2026-01-08": "box",
  "2026-01-09": "spray bottle",
  "2026-01-10": "recycle",
  "2026-01-11": "clothesline",
  "2026-01-12": "star",
  "2026-01-13": "rocket",
  "2026-01-14": "astronaut",
  "2026-01-15": "orbit",
  "2026-01-16": "alien",
  "2026-01-17": "telescope",
  "2026-01-18": "solar system",
  "2026-01-19": "hat",
  "2026-01-20": "watch",
  "2026-01-21": "gem",
  "2026-01-22": "bow tie",
  "2026-01-23": "pearl",
  "2026-01-24": "scarf",
  "2026-01-25": "sparkle",
  "2026-01-26": "pig",
  "2026-01-27": "corn",
  "2026-01-28": "overalls",
  "2026-01-29": "pitchfork",
  "2026-01-30": "scarecrow",
  "2026-01-31": "windmill",
  "2026-02-01": "hose",
};

export function getTodaysPrompt() {
  const todayString = getTodayString();
  return PromptsByDay[todayString] ?? "cookie";
}

export function getTodayString() {
  const today = new Date();

  return (
    today.getFullYear() +
    "-" +
    ("0" + (today.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + today.getDate()).slice(-2)
  );
}
